import React from 'react';
import style from './style.module.scss';
import { useFetch } from '@/hooks';
import { navData } from '@/constants';
import { NavDataProps } from '@/constants/navData';
import Link from 'next/link';

import Image from 'next/image';

import leftLogo from '@/public/footer-left.png';
import rightLogo from '@/public/footer-right.png';

export const Footer = async () => {
  const { data } = await useFetch(process.env.NEXT_PUBLIC_API_URL + '/kontakty?populate=*');

  if (!data) {
    return <p>Произошла ошибка...</p>;
  }
  return (
    <footer className={style.footer}>
      <div className={style.logos}>
        <Image width={64} height={128} src={leftLogo} alt="logo" />
        <Image width={64} height={128} src={rightLogo} alt="logo" />
      </div>
      <div className="container">
        <div className={style.content}>
          <div className={style.left}>
            {navData.map((elem: NavDataProps, index) => {
              return (
                <Link key={index} href={elem?.link}>
                  {elem?.footer_title ? elem.footer_title : elem.title}
                </Link>
              );
            })}
          </div>
          <div className={style.middle}>
            <Link target='_blank' href={'https://ronix.ru/'}>Создание сайта – Ronix Systems</Link>
          </div>
          <div className={style.right}>
            <div className={''}>
              <p>{data?.address}</p>
              <Link className={style.mail} href={`mailto:${data?.email}`}>
                {data?.email}
              </Link>
            </div>
            <div className={''}>
              <Link href={`tel:${data?.phoneOne}`}>{data?.phoneOne}</Link>
              <Link href={`tel:${data?.phoneTwo}`}>{data?.phoneTwo}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
